/*
 * Copyright 2016 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 - http://www.apache.org/licenses/LICENSE-2.0
 */
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var React = require("react");
var popover_1 = require("./popover");
var SVGPopover = (function (_super) {
    __extends(SVGPopover, _super);
    function SVGPopover() {
        _super.apply(this, arguments);
    }
    SVGPopover.prototype.render = function () {
        return React.createElement(popover_1.Popover, __assign({rootElementTag: "g"}, this.props), this.props.children);
    };
    return SVGPopover;
}(React.Component));
exports.SVGPopover = SVGPopover;
exports.SVGPopoverFactory = React.createFactory(SVGPopover);

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9jb21wb25lbnRzL3BvcG92ZXIvc3ZnUG9wb3Zlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7OztHQUdHOzs7Ozs7Ozs7Ozs7Ozs7QUFFSCxJQUFZLEtBQUssV0FBTSxPQUFPLENBQUMsQ0FBQTtBQUUvQix3QkFBdUMsV0FBVyxDQUFDLENBQUE7QUFFbkQ7SUFBZ0MsOEJBQWtDO0lBQWxFO1FBQWdDLDhCQUFrQztJQUlsRSxDQUFDO0lBSFUsMkJBQU0sR0FBYjtRQUNJLE1BQU0sQ0FBQyxvQkFBQyxpQkFBTyxZQUFDLGNBQWMsRUFBQyxHQUFHLEdBQUssSUFBSSxDQUFDLEtBQUssR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLFFBQVMsQ0FBVSxDQUFDO0lBQ3ZGLENBQUM7SUFDTCxpQkFBQztBQUFELENBSkEsQUFJQyxDQUorQixLQUFLLENBQUMsU0FBUyxHQUk5QztBQUpZLGtCQUFVLGFBSXRCLENBQUE7QUFFVSx5QkFBaUIsR0FBRyxLQUFLLENBQUMsYUFBYSxDQUFDLFVBQVUsQ0FBQyxDQUFDIiwiZmlsZSI6ImNvbXBvbmVudHMvcG9wb3Zlci9zdmdQb3BvdmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLypcbiAqIENvcHlyaWdodCAyMDE2IFBhbGFudGlyIFRlY2hub2xvZ2llcywgSW5jLiBBbGwgcmlnaHRzIHJlc2VydmVkLlxuICogTGljZW5zZWQgdW5kZXIgdGhlIEFwYWNoZSBMaWNlbnNlLCBWZXJzaW9uIDIuMCAtIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuICovXG5cbmltcG9ydCAqIGFzIFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuXG5pbXBvcnQgeyBJUG9wb3ZlclByb3BzLCBQb3BvdmVyIH0gZnJvbSBcIi4vcG9wb3ZlclwiO1xuXG5leHBvcnQgY2xhc3MgU1ZHUG9wb3ZlciBleHRlbmRzIFJlYWN0LkNvbXBvbmVudDxJUG9wb3ZlclByb3BzLCB7fT4ge1xuICAgIHB1YmxpYyByZW5kZXIoKSB7XG4gICAgICAgIHJldHVybiA8UG9wb3ZlciByb290RWxlbWVudFRhZz1cImdcIiB7Li4udGhpcy5wcm9wc30+e3RoaXMucHJvcHMuY2hpbGRyZW59PC9Qb3BvdmVyPjtcbiAgICB9XG59XG5cbmV4cG9ydCB2YXIgU1ZHUG9wb3ZlckZhY3RvcnkgPSBSZWFjdC5jcmVhdGVGYWN0b3J5KFNWR1BvcG92ZXIpO1xuIl0sInNvdXJjZVJvb3QiOiIvc291cmNlLyJ9



/*****************
 ** WEBPACK FOOTER
 ** ./~/@blueprintjs/core/dist/components/popover/svgPopover.js
 ** module id = 457
 ** module chunks = 0
 **/